import { render } from "./DrawerPanel.vue?vue&type=template&id=ed9e7f4a"
import script from "./DrawerPanel.vue?vue&type=script&lang=js"
export * from "./DrawerPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__